var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemini({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 60,
    viewBox: "0 0 162 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4024 45C26.7705 45 31.1889 40.9382 31.7456 35.7234C36.9659 35.1673 41.0321 30.7536 41.0321 25.3913C41.0321 19.6523 36.3748 15 30.6297 15C25.2616 15 20.8432 19.0618 20.2865 24.2766C15.0662 24.8327 11 29.2464 11 34.6087C11 40.3477 15.6573 45 21.4024 45ZM13.4352 33.435C13.9478 29.9321 16.7207 27.1622 20.2274 26.65V33.435H13.4352ZM21.4024 42.6525C17.3543 42.6525 14.0039 39.6686 13.4352 35.7825H29.3696C28.8008 39.6686 25.4504 42.6525 21.4024 42.6525ZM29.4547 26.565L22.5774 26.565V33.435H29.4547L29.4547 26.565ZM30.6297 17.3475C26.5817 17.3475 23.2313 20.3314 22.6625 24.2175L38.5969 24.2175C38.0282 20.3314 34.6778 17.3475 30.6297 17.3475ZM31.8047 33.35C35.3114 32.8378 38.0842 30.0679 38.5969 26.565L31.8047 26.565L31.8047 33.35Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1913 25.4085L67.8329 22.8193C66.7212 21.7376 63.475 19.6709 59.3831 20.0575C54.2683 20.5408 50.2422 24.3038 50.2422 29.2232C50.2422 34.1427 53.2488 39.1312 58.8993 39.5972C63.4197 39.9701 67.1532 38.0495 68.455 37.0426V28.4637H59.4004V31.3636H65.0854V35.2129C63.9104 35.9091 60.8865 37.0598 58.1908 36.0932C54.8213 34.8849 53.7327 32.3475 53.6981 29.3613C53.6635 26.3751 56.2555 23.5788 59.4004 23.1991C62.5453 22.8193 65.3273 24.7181 66.1913 25.4085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4811 20.2819V39.3211H87.4453V36.3003H75.747V31.0184H85.4236V27.9977H75.747V23.3372H87.428V20.2647L72.4811 20.2819Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1777 39.3383V20.2819L94.1326 20.2647L101.58 29.1715L108.993 20.2992H111.948V39.3383H108.596V25.7883L101.978 33.7457H101.165L94.5646 25.8055V39.3383H91.1777Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.236 20.2819V39.3211H128.588V25.8055L140.027 39.3383H142.896V20.2819H139.544V33.8493L128.122 20.2819H125.236Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.924 20.2819H120.242V39.3038H116.924V20.2819Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151 20.2819H147.682V39.3038H151V20.2819Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.4702ec2a63dda0c10c826af78e17407c.svg";
export { ForwardRef as ReactComponent };